import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SnackbarService } from './snackbar.service';
import { SnackbarType } from '@shared/types/snackbar-type.enum';
import { SnackbarClass } from '@shared/types/snackbar-class.enum';

@Component({
  selector: 'esignatur-snackbar',
  imports: [],
  templateUrl: './esignatur-snackbar.html',
  styleUrl: './esignatur-snackbar.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsignaturSnackbar {
  private readonly snackbarService = inject(SnackbarService);
  protected readonly messages = this.snackbarService.messagesSignal;
  protected readonly SnackbarType = SnackbarType;

  protected closeSnackbar(id: string): void {
    this.snackbarService.remove(id);
  }

  protected getSnackbarClasses(type: SnackbarType): SnackbarClass {
    switch (type) {
      case SnackbarType.SUCCESS:
        return SnackbarClass.SUCCESS;
      case SnackbarType.ERROR:
        return SnackbarClass.ERROR;
      case SnackbarType.WARNING:
        return SnackbarClass.WARNING;
      case SnackbarType.INFO:
        return SnackbarClass.INFO;
    }
  }
}
